import type { AddressResponse } from '../api/types';

/**
 * Builds a Google Maps search URL for an address.
 *
 * Prefers coordinates when the address has real ones — 0,0/null is the
 * backend's placeholder for shipments created without Places autocomplete,
 * so it's treated as "no coordinates" and the fallback text query
 * (`line, city`, or fallbackLine/fallbackCity if there's no address at all)
 * is used instead.
 */
export function buildMapsUrl(
  address: AddressResponse | null,
  fallbackLine: string,
  fallbackCity: string,
): string {
  const hasCoords = address != null && !!(address.latitude || address.longitude);
  if (hasCoords) {
    return `https://www.google.com/maps/search/?api=1&query=${address!.latitude},${address!.longitude}`;
  }

  const line = address?.line || fallbackLine;
  const city = address?.city || fallbackCity;
  const query = [line, city].filter(Boolean).join(', ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
